import LogInOrSignUpPage from './LogInOrSignUpPage';

export default LogInOrSignUpPage;
